
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-hooks-use-graph-store-demo-xflow-hooks-use-graph-store"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.zh.md?type=demo')
};